/**
 * The length to truncate content titles.
 * @const {number}
 */
export const CONTENT_TITLE_LENGTH = 28;

/**
 * The length to truncate category titles.
 * @const {number}
 */
export const CATEGORY_TITLE_LENGTH = 28;

/**
 * The long date format used in the smart table date columns.
 * @const {string}
 */
export const MOMENT_LONG_DATE_FORMAT = 'MMM Do YYYY, h:mm:ss a';

/**
 * The full date format used when a fuller date/time display is needed (e.g. "January 5, 2026 9:00 AM").
 * @const {string}
 */
export const MOMENT_FULL_DATE_FORMAT = 'MMMM D, YYYY h:mm A';

